<script>
  import { format } from 'svelte-i18n';
  import { Input } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Select } from '@client/components/select';

  import { OPERATORS } from './liquid-builder';

  /**
   * One clause row in the dynamic-members builder.
   * Strictly prop-down / event-up — never mutates `clause` directly; callers
   * own state and receive the updated clause via `onChange`.
   */
  export let clause = { variable: '', operatorId: 'contains', value: '' };
  export let availableFields = [];
  export let onChange = () => {};
  export let onRemove = () => {};
  export let canRemove = true;

  $: fieldOptions = (availableFields || []).map((name) => ({ label: name, value: name }));
  $: operatorOptions = OPERATORS.map(({ id, labelKey }) => ({ label: $format(labelKey), value: id }));

  $: fieldSelection = clause.variable ? { label: clause.variable, value: clause.variable } : null;
  $: operatorSelection = operatorOptions.find((o) => o.value === clause.operatorId) || operatorOptions[0];

  const onVariableChange = (event) => {
    const selection = event?.detail;
    onChange({ ...clause, variable: selection?.value ?? '' });
  };

  const onVariableClear = () => {
    onChange({ ...clause, variable: '' });
  };

  const onOperatorChange = (event) => {
    const selection = event?.detail;
    onChange({ ...clause, operatorId: selection?.value ?? 'contains' });
  };

  const onValueInput = (event) => {
    onChange({ ...clause, value: event.target.value });
  };
</script>

<div class="clause-row">
  <span class="fields-prefix" aria-hidden="true">fields.</span>

  <span class="picker variable-picker">
    <Select
      items={fieldOptions}
      value={fieldSelection}
      on:change={onVariableChange}
      on:clear={onVariableClear}
      placeholder={$format('label.SELECT_FIELD')}
      searchable
    />
  </span>

  <span class="picker operator-picker">
    <Select
      items={operatorOptions}
      value={operatorSelection}
      on:change={onOperatorChange}
      placeholder={$format('label.OPERATOR_CONTAINS')}
      clearable={false}
    />
  </span>

  <span class="value-input">
    <Input type="text" placeholder={$format('label.VALUE')} value={clause.value} on:input={onValueInput} />
  </span>

  <button
    type="button"
    class="remove-btn"
    aria-label={$format('label.REMOVE_CONDITION')}
    title={$format('label.REMOVE_CONDITION')}
    on:click={() => onRemove()}
    disabled={!canRemove}
  >
    <Icon name="trash" />
  </button>
</div>

<style lang="scss" src="./clause-row.scss"></style>
